export const lazyRetry = (componentImport) => {
    return componentImport().catch(() => componentImport());
};